module.exports = __webpack_public_path__ + "static/img/img_3.9493c97.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/code/img_3.jpg
// module id = 90
// module chunks = 20